// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KWyf","col":"styles_col__1rALc","actions":"styles_actions__3A3RU","conflict":"styles_conflict__17IWE"};